<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <img src="./assets/images/Schedules_Icon.png">
          <span>Failed Messages</span>
        </p>
      </div>
      <md-card>
        <md-card-content>
        <div class="div-message">
            <span *ngIf="messagesCount > 0" class="count">{{messagesCount}}</span>
            <span class="msg-text">{{messageText}} </span>
            <button [disabled]= "messagesCount == 0" md-raised-button class="glbAdminBtnCls1 push-btn" (click)="onPushMessage()">
              PUSH ALL MESSAGES</button>
        </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
  </section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-eligibility-messages/adm-eligibility-messages.component.html